<div class="wrapper-table">
  <table
    mat-table
    matSort
    cdkDropList
    [id]="name"
    aria-label="Transfer table"
    [dataSource]="transfer[name].dataSource"
    [cdkDropListConnectedTo]="[name === 'source' ? 'target' : 'source']"
    (cdkDropListDropped)="transfer.onDropItem(name, $event)"
    (matSortChange)="transfer.onSortColumn(name, $event)"
  >
    <!-- Columns -->
    <ng-container *ngFor="let column of transfer[name].columns" matColumnDef="{{ column.id }}">
      <!-- Header -->
      <th mat-header-cell *matHeaderCellDef>
        <ng-container [ngSwitch]="column.type">
          <div *ngSwitchCase="'checkbox'" class="wrapper-cell">
            <div class="mat-cell">
              <mat-checkbox
                [checked]="column.checked"
                [disabled]="!transfer[name].dataSource.length"
                (click)="$event.stopPropagation()"
                (change)="transfer.onSelectAllItems(name, column, $event)"
              >
              </mat-checkbox>
            </div>
          </div>
          <div *ngSwitchCase="'input'" class="wrapper-cell" mat-sort-header [disabled]="column.sort?.disabled">
            <div class="mat-cell">
              {{ column.title }}
            </div>
          </div>
        </ng-container>
      </th>
      <!-- Cell -->
      <td mat-cell *matCellDef="let row">
        <ng-container [ngSwitch]="column.type">
          <div *ngSwitchCase="'checkbox'" class="wrapper-cell">
            <div class="mat-cell">
              <mat-checkbox
                [checked]="row?.selected"
                (click)="$event.stopPropagation()"
                (change)="transfer.onSelectItem(name, row)"
              >
              </mat-checkbox>
            </div>
          </div>
          <div *ngSwitchCase="'input'" class="wrapper-cell">
            <div class="cell">
              {{ row[column.id] }}
            </div>
          </div>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="transfer.displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: transfer.displayedColumns"
      cdkDrag
      class="drag-element"
      [cdkDragData]="row"
      (cdkDragStarted)="transfer.onDragStarted($event)"
    ></tr>
    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4" style="vertical-align: middle">No data</td>
    </tr>
  </table>
  <div class="transfer-footer"></div>
</div>
